import { useLocation } from "react-router-dom"
import { AppSidebar } from "@/components/app-sidebar"
import {
  SidebarInset,
  SidebarProvider,
} from "@/components/ui/sidebar"
import { LayoutProps } from '@/client/types/admin/types';
import RestrictedPage from "./RestrictedPage";
import { SiteHeader } from "@/components/site-header";
import FeatureGate from "./FeatureGate";
import RequirePermission from "./RequirePermission";
import { resolvePermissionForPath } from "@/client/config/permissions";

// Gates the current route by its path→code mapping. `null` is an explicit
// allowlist entry. Unmapped paths are denied (superadmin still passes).
const UNMAPPED = '__unmapped__';
const RouteGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const code = resolvePermissionForPath(pathname);
  if (code === null) return <>{children}</>;
  return <RequirePermission code={code ?? UNMAPPED}>{children}</RequirePermission>;
};

const AdminLayout: React.FC<LayoutProps> = ({
  children,
  title,
  description
}) => {
  return (
    <RestrictedPage>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset className="pt-0 min-w-0 overflow-x-hidden">
          <SiteHeader title={title} description={description} />
          <div className="flex min-w-0 w-full flex-1 flex-col bg-gray-50">
            <div className="@container/main flex min-w-0 w-full flex-1 flex-col overflow-x-hidden bg-gray-50">
              <div className="flex h-full w-full flex-col gap-4 overflow-x-auto py-4 md:gap-6 md:py-6">
                <RouteGuard>
                  <FeatureGate>{children}</FeatureGate>
                </RouteGuard>
              </div>
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </RestrictedPage>
  )
}

export default AdminLayout